export const AUTHORIZE_USER = 'AUTHORIZE_USER';
export const LOGOUT = 'LOGOUT';
export const CLEAN_THINGS = 'CLEAN_THINGS';
export const TEMPORARY_SAVE_SOMTHING = 'TEMPORARY_SAVE_SOMTHING';
export const IS_LOADING = 'IS_LOADING';
export const MODAL = 'MODAL';
export const SHOW_ERROR = 'SHOW_ERROR';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const CLEAR_MODAL = 'CLEAR_MODAL';
